// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".side-nav-outer-toolbar {\n  flex-direction: column;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.layout-header {\n  z-index: 1501;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
